import _ from "lodash";
import { TemplateActions, URLParams } from "components/EditorHome/Constants";
import { DocumentType } from "constants/TemplateEditor";
import { getMessageTemplateAvailability } from "functions";

/**
 * @description - Get all url parameters
 * @param {string} search history object
 * @returns {string} - Generated rule with exact format
 */
export const getUrlParams = (
  search: any
): {
  groupId: string | null | undefined;
  categoryId: string | null | undefined;
  filtered: boolean | null | undefined;
  templateId: string | null | undefined;
  documentType: string | null | undefined;
} => {
  try {
    const urlParams = new URLSearchParams(search);
    const categoryId = urlParams.get(URLParams.CATEGORY_ID);
    const groupId = urlParams.get(URLParams.GROUP_ID);
    const filtered = Boolean(urlParams.get(URLParams.FILTERED) == "true");
    const templateId = urlParams.get(URLParams.TEMPLATE_ID);
    const documentType = urlParams.get(URLParams.DOCUMENT_TYPE);
    return {
      categoryId,
      groupId,
      filtered,
      templateId,
      documentType,
    };
  } catch (error) {
    return {
      categoryId: null,
      groupId: null,
      filtered: false,
      templateId: null,
      documentType: null,
    };
  }
};

/**
 * @description - Set initial url parameters (uses history replace semantics)
 * @param {Array<any>} groups Array of groups
 * @param {any} search history/location.search string
 * @param {any} navigateOrReplace react-router navigate function (v6) or legacy replace callback
 */
export const initSetUrlParams = (
  groups: Array<any>,
  search: any,
  navigateOrReplace: any
) => {
  try {
    if (groups?.length > 0) {
      const urlParams = new URLSearchParams(search);
      const { categoryId, groupId } = getUrlParams(search);
      urlParams.set(URLParams.GROUP_ID, groupId ?? groups[0].groupId);
      urlParams.set(
        URLParams.CATEGORY_ID,
        categoryId ?? groups[0].categories[0].categoryId
      );
      // Prefer react-router v6 navigate with { replace: true }
      try {
        navigateOrReplace({ search: urlParams.toString() }, { replace: true });
      } catch (err) {
        // Fallback to legacy signature
        navigateOrReplace({ search: urlParams.toString() });
      }
    } else {
      try {
        navigateOrReplace({ search: "" }, { replace: true });
      } catch (err) {
        navigateOrReplace({ search: "" });
      }
    }
  } catch (e) {}
};

/**
 * @description - Navigation for editor page
 * @param {any} push
 * @param {any} template Type of the document
 * @param {any} event event
 */
export const navigateToEditor = (push: any, template?: any, event?: any) => {
  try {
    const { templateId, outPutFormat, categoryId, groupId } = template ?? {};
    if (event && event.ctrlKey) {
      if (templateId == 0) {
        const url =
          outPutFormat == DocumentType.EHF
            ? `/ehf-template-editor?${URLParams.GROUP_ID}=${groupId}&${URLParams.CATEGORY_ID}=${categoryId}&${URLParams.DOCUMENT_TYPE}=${outPutFormat}`
            : `/template-editor?${URLParams.GROUP_ID}=${groupId}&${URLParams.CATEGORY_ID}=${categoryId}&${URLParams.DOCUMENT_TYPE}=${outPutFormat}`;
        window.open(url, "_blank");
      } else {
        const url =
          outPutFormat == DocumentType.EHF
            ? `/ehf-template-editor?${URLParams.GROUP_ID}=${groupId}&${URLParams.CATEGORY_ID}=${categoryId}&id=${templateId}&${URLParams.DOCUMENT_TYPE}=${outPutFormat}`
            : `/template-editor?${URLParams.GROUP_ID}=${groupId}&${URLParams.CATEGORY_ID}=${categoryId}&id=${templateId}&${URLParams.DOCUMENT_TYPE}=${outPutFormat}`;
        window.open(url, "_blank");
      }
    } else {
      if (templateId == 0) {
        outPutFormat == DocumentType.EHF
          ? push(
              `/ehf-template-editor?${URLParams.GROUP_ID}=${groupId}&${URLParams.CATEGORY_ID}=${categoryId}&${URLParams.DOCUMENT_TYPE}=${outPutFormat}`
            )
          : push(
              `/template-editor?${URLParams.GROUP_ID}=${groupId}&${URLParams.CATEGORY_ID}=${categoryId}&${URLParams.DOCUMENT_TYPE}=${outPutFormat}`
            );
      } else {
        outPutFormat == DocumentType.EHF
          ? push(
              `/ehf-template-editor?${URLParams.GROUP_ID}=${groupId}&${URLParams.CATEGORY_ID}=${categoryId}&id=${templateId}&${URLParams.DOCUMENT_TYPE}=${outPutFormat}`
            )
          : push(
              `/template-editor?${URLParams.GROUP_ID}=${groupId}&${URLParams.CATEGORY_ID}=${categoryId}&id=${templateId}&${URLParams.DOCUMENT_TYPE}=${outPutFormat}`
            );
      }
    }
  } catch (e) {}
};

/**
 * @description - get template actions
 * @param {string}  groupName - Group name
 * @param {string} categoryName - Category name
 * @returns {TemplateActions[]} action list
 */
export const getTemplateActions = (
  groupName: string,
  categoryName: string
): TemplateActions[] => {
  let actions = [
    TemplateActions.COPY,
    TemplateActions.DOWNLOAD,
    TemplateActions.ACTIVATE_OR_DEACTIVATE,
  ];
  try {
    const isEnabledMessageTemplate = getMessageTemplateAvailability(
      groupName,
      categoryName
    );
    if (isEnabledMessageTemplate) {
      actions?.splice(2, 0, TemplateActions.ADD_TO_MAESSAGE_TEMPLATES);
    }
    return actions;
  } catch (error) {
    return actions;
  }
};
